import { useQuery } from '@tanstack/react-query';
import { homeAPI } from '../api/homeAPI';

export const mindboxUserInfoQueryKey = ['mindbox-user-info'];

type MindboxBalance = {
  total?: number;
  /** Сколько можно потратить; total ещё включает заблокированные баллы. */
  available?: number;
  systemName?: string;
};

type BalancesHolder = { balances?: MindboxBalance[] };

type MindboxUserInfoResponse = BalancesHolder & {
  user?: BalancesHolder;
  /** Так баланс приходит в ответе Mindbox как есть — например, в loyalty/qr. */
  customer?: BalancesHolder;
  data?: MindboxUserInfoResponse;
};

// Бэкенд отдаёт баланс по-разному: `/mb/user-info` — в `user.balances`,
// `loyalty/qr` — ответом Mindbox в `customer.balances`. Читаем любой.
const findBalances = (data?: MindboxUserInfoResponse): MindboxBalance[] | undefined =>
  data?.user?.balances ??
  data?.customer?.balances ??
  data?.balances ??
  (data?.data ? findBalances(data.data) : undefined);

// Показываем и списываем доступные баллы, а не total: заблокированные
// (blocked) потратить нельзя.
const getAvailablePoints = (data?: MindboxUserInfoResponse) => {
  const balances = findBalances(data);
  if (!balances?.length) {
    return 0;
  }

  const main = balances.find(balance => balance.systemName === 'Main') ?? balances[0];

  return main?.available ?? 0;
};

export const useGetMindboxUserInfo = (enabled = true) => {
  const { data = { availablePoints: 0 }, isPending } = useQuery({
    queryKey: mindboxUserInfoQueryKey,
    queryFn: async () => await homeAPI.getMindboxUserInfo(),
    enabled,
    select: data => ({
      availablePoints: getAvailablePoints(data.data),
    }),
  });

  return {
    ...data,
    // Пока баланса нет, вместо нуля показываем шиммер. isPending, а не
    // isLoading: до включения запроса (профиль ещё грузится) данных тоже нет.
    isLoading: enabled && isPending,
  };
};
